import React, { useEffect, useState } from 'react'
import { v2_projects, v2_ships } from '../../../../actions/v2/projectAndVessel';

import { encodeBase64UrlJsonPayload } from '../../../../utils';
import { useDebouncedValue } from '../../../../customHook/useDebouncedValue';
const SearchFilter = ({ onSearch }) => {
    const [state, setState] = useState({
        yard: { name: 'yard', value: '', options: [] },
        ship: { name: 'ship', value: '', options: [] },
        referenceNumber: { name: 'referenceNumber', value: '' },

    });


    const handleChange = (e) => {
        const { name, value } = e.target;

        setState((prev) => ({
            ...prev,
            [name]: {
                ...prev[name],
                value,
            },
        }));
    };

    // Typing fires one request per keystroke otherwise, and the responses come
    // back out of order — that is the "sometimes works" the users see.
    const debouncedReferenceNumber = useDebouncedValue(state.referenceNumber.value, 400);



    useEffect(() => {
        v2_ships(null, null, state.yard.value).then((res) => {
            if (res.status) {
                setState((prev) => ({
                    ...prev,
                    // Drop a hull that the new parent no longer offers, otherwise the
                    // stale id stays in the filter and the list comes back empty.
                    ship: {
                        ...prev.ship,
                        options: res.result,
                        value: res.result.some((item) => String(item.ID) === String(prev.ship.value))
                            ? prev.ship.value
                            : '',
                    },
                }));
            }
        });

    }, [state.yard.value]);

    useEffect(() => {
        onSearch(encodeBase64UrlJsonPayload({
            shipId: state.ship.value,
            yardId: state.yard.value,
            referenceNumber: debouncedReferenceNumber.trim(),
        }))
    }, [state.yard.value, state.ship.value, debouncedReferenceNumber])


    return (
        <div className="row">
            <div className="col-lg-12">
                <div className="card">
                    <div className="card-body card-body-search">
                        <div
                            className="row gy-12 gx-12 align-items-center"
                        >
                            <div className="row">

                                <div className="form-group col-md-2">
                                    <label htmlFor="inputEmail4" className="col-form-label">
                                        Yard
                                    </label>
                                    <select className="form-select"
                                        value={state.yard.value}
                                        name={state.yard.name}
                                        onChange={handleChange}
                                    >
                                        <option value="">All Yard</option>
                                        {state.yard.options.map((item) => (
                                            <option key={item.ID} value={item.ID}>
                                               {item.YARD_NAME}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="form-group col-md-2">
                                    <label htmlFor="inputEmail4" className="col-form-label">
                                        Hull
                                    </label>
                                    <select className="form-select"
                                        value={state.ship.value}
                                        name={state.ship.name}
                                        onChange={handleChange}
                                    >
                                        <option value="">All Hull</option>

                                        {state.ship.options.map((item) => (
                                            <option key={item.ID} value={item.ID}>
                                                {item.HULL_NUMBER} - {item.SHIP_NAME}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="form-group col-md-2">
                                    <label htmlFor="inputState" className="col-form-label">
                                        Reference Number
                                    </label>
                                    <input
                                        type="text"
                                        placeholder='Reference Number'
                                        className="form-control"
                                        id="REFERENCE_NUMBER"
                                        value={state.referenceNumber.value}
                                        name={state.referenceNumber.name}
                                        onChange={handleChange}
                                    />
                                </div>
                                
                            </div>
                        </div>
                    </div>
                    {/* end card body */}
                </div>
                {/* end card */}
            </div>
            {/* end col */}
        </div>

    )
}

export default SearchFilter